import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
} from "@material-ui/core";

import { IAdminOrder } from "../types";

interface ICreateInvoiceModalProps {
  order: IAdminOrder;
  isOpen: boolean;
  onClose: () => void;
}

export const OrderDetailsModal = ({
  order,
  isOpen,
  onClose,
}: ICreateInvoiceModalProps) => {
  const deliveryLocation = order.deliveryLocationId ?? {};

  const {
    isContactPersonRequired = false,
    address = "N/A",
    tankConnectionDetails = "N/A",
    city = "N/A",
    zipCode = "N/A",
    gpsInaccurateDescription = "N/A",
    tankDistance = "N/A",
    gatedPropertyDetails = "N/A",
    phoneNumber = "N/A",
    name = "N/A",
  } = deliveryLocation;
  // The backend derives this ahead of time so the admin view stays consistent
  // with what we send to TSheets and avoids duplicating parsing logic in React.
  const deliveryInstructionNotes = order.deliveryInstructionNotes?.trim() || "N/A";
  const quickbooksShippingCoordinates =
    order.quickbooksShippingCoordinates?.trim() || "N/A";

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      open={isOpen}
      aria-labelledby="form-dialog-title"
    >
      <Button
        onClick={onClose}
        style={{ width: "2rem", alignSelf: "flex-end" }}
      >
        X
      </Button>
      <DialogTitle id="form-dialog-title">
        Delivery Location Details
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          justifyContent="space-around"
          flexDirection="column"
        >
          <Box width="14rem">Name: {name}</Box>
          <Box width="14rem">
            Address: {address}, {city}, {zipCode}
          </Box>
          <Box width="14rem">Phone Number: {phoneNumber}</Box>
          <Box width="14rem">
            Contact Person Required: {isContactPersonRequired ? "yes" : "no"}
          </Box>
          <Box width="14rem">Gps Description: {gpsInaccurateDescription}</Box>
          <Box width="14rem">Gated Property Details: {gatedPropertyDetails}</Box>
          <Box width="14rem">Tank Distance: {tankDistance}</Box>
          <Box width="14rem">
            Tank Connection Details: {tankConnectionDetails}
          </Box>
          <Box width="14rem">
            QBO Shipping Coordinates: {quickbooksShippingCoordinates}
          </Box>
          <Box width="100%" mt={2}>
            <strong>Delivery Instructions:</strong>
            <Box component="pre" mt={1} style={{ whiteSpace: "pre-wrap", margin: 0 }}>
              {deliveryInstructionNotes}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
